import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  splitKnown,
} from "../utils";

export class ProductVersionFactoryPricingBracketModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    quantityUnder: {
      label: "Quantity Under",
      fieldType: "number",
      allowNull: true,
    },
    price: { label: "Price", fieldType: "number", allowNull: true },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  quantityUnder!: number | null;
  price!: number | null;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("quantityUnder", null);
    this.defineObservableValue("price", null);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product factory pricing bracket");
    this.quantityUnder = readOptionalNumber(source, "quantityUnder");
    this.price = readOptionalNumber(source, "price");
    this.extra = splitKnown(source, ["quantityUnder", "price"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.quantityUnder === null
        ? {}
        : { quantityUnder: this.quantityUnder }),
      ...(this.price === null ? {} : { price: this.price }),
    };
  }
}
